<div class="app-notifier-container" [ngClass]="sidebarState">
    <div #viewContainer></div>
</div>
